module.exports = __webpack_public_path__ + "static/media/marknad.cd20bfed.jpg";